/**
 * Date/time display helpers — delegate to regional settings (see regionalFormat.js).
 * Internal storage and API payloads remain 24h HH:mm / ISO.
 */
export {
  toDateSafe,
  formatDate,
  formatDateTime,
  formatTime,
  formatTimeFromHhMm,
  formatDateInput,
  parseDateInput,
  parseRegionalDate,
  formatRegionalDate,
  toISODateFromInput,
  toISODateFromRegional,
  toRegionalDateFromISO,
  toRegionalDateFromRegional,
  isDateOnOrBeforeToday,
  formatDateTimeInput,
  parseDateTimeInput,
  toISODateTimeFromInput,
  toRegionalDateTimeFromISO,
  getDateFormatPlaceholder,
  getDateTimeFormatPlaceholder,
  getTimeFormatPlaceholder,
  todayIso,
  academyYear,
} from './regionalFormat';

import {
  toDateSafe,
  formatDate,
  formatDateTime,
  formatTime,
  formatDateTime as formatDateTimeRegional,
  parseDateInput,
  toISODateFromInput,
  toRegionalDateFromISO,
  getDateFormatPlaceholder,
  formatDateInput,
  academyTodayDate,
} from './regionalFormat';

export { academyTodayDate, academyNowParts, academyNowDate } from './regionalFormat';

export function todayRegionalDate() {
  return formatDateInput(academyTodayDate());
}

export function regionalDateDaysAgo(days) {
  const dt = academyTodayDate();
  dt.setDate(dt.getDate() - days);
  return formatDateInput(dt);
}

export function firstDayOfMonthRegional() {
  const today = academyTodayDate();
  return formatDateInput(new Date(today.getFullYear(), today.getMonth(), 1));
}

export function formatLocalDateTime(value) {
  return formatDateTimeRegional(value);
}

/** @deprecated Use formatLocalDateTime */
export const formatISTDisplay = formatLocalDateTime;

export function toDDMMYYYY(value) {
  return formatDate(value);
}

export function toISODate(value) {
  if (!value) return '';
  const d = toDateSafe(value);
  if (!d) return '';
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

/** @deprecated Use parseDateInput / parseRegionalDate */
export const parseDDMMYYYYToDate = parseDateInput;

/** @deprecated Use toISODateFromInput / toISODateFromRegional */
export const ddmmyyyyToIso = toISODateFromInput;

/** @deprecated Use toRegionalDateFromISO */
export const isoToDDMMYYYY = toRegionalDateFromISO;

export default {
  toDateSafe,
  formatDate,
  formatLocalDateTime,
  formatISTDisplay,
  toDDMMYYYY,
  toISODate,
  parseDDMMYYYYToDate,
  parseRegionalDate: parseDateInput,
  ddmmyyyyToIso,
  toISODateFromRegional: toISODateFromInput,
  isoToDDMMYYYY,
  toRegionalDateFromISO,
  formatDateTime,
  formatTime,
  getDateFormatPlaceholder,
};
